module.exports = __webpack_public_path__ + "static/media/signup.dc2d7a43.ico";